export function lineMarkerElements(instance) {
  if (!instance?.el) return []

  const grouped = instance.el.querySelectorAll(".apexcharts-series-markers .apexcharts-marker")
  if (grouped.length > 0) return grouped

  const areaMarkers = instance.el.querySelectorAll(".apexcharts-area-series .apexcharts-marker")
  if (areaMarkers.length > 0) return areaMarkers

  return instance.el.querySelectorAll(".apexcharts-line-series .apexcharts-marker") || []
}

export function markerIndexFromElement(marker) {
  const raw = marker.getAttribute("j") ?? marker.getAttribute("index")
  if (raw == null || raw === "") return null
  const index = Number.parseInt(raw, 10)
  return Number.isFinite(index) ? index : null
}

export function markerElementForIndex(instance, index) {
  if (index == null || !instance?.el) return null

  const active = instance.el.querySelector(".apexcharts-marker.apexcharts-active")
  if (active && markerIndexFromElement(active) === index) return active

  const markers = lineMarkerElements(instance)
  const matched = [...markers].find((marker) => markerIndexFromElement(marker) === index)
  if (matched) return matched

  return markers[index] || null
}

function pointFromMarkerElement(marker) {
  const x = Number.parseFloat(marker.getAttribute("cx"))
  const y = Number.parseFloat(marker.getAttribute("cy"))
  if (!Number.isFinite(x) || !Number.isFinite(y)) return null
  return { x, y }
}

export function markerCenter(instance, index) {
  if (index == null || !instance) return null

  const active = instance.el?.querySelector(".apexcharts-marker.apexcharts-active")
  if (active && markerIndexFromElement(active) === index) {
    const activePoint = pointFromMarkerElement(active)
    if (activePoint) return activePoint
  }

  const markers = lineMarkerElements(instance)
  const matched = [...markers].find((marker) => markerIndexFromElement(marker) === index)
  if (matched) {
    const matchedPoint = pointFromMarkerElement(matched)
    if (matchedPoint) return matchedPoint
  }

  const globals = instance.w?.globals
  const x = globals?.seriesXvalues?.[0]?.[index]
  const y = globals?.seriesYvalues?.[0]?.[index]
  if (Number.isFinite(x) && Number.isFinite(y)) return { x, y }

  const fallback = markers[index]
  if (!fallback) return null

  return pointFromMarkerElement(fallback)
}

export function seriesPixelPointsFromMarkers(instance) {
  const points = [...lineMarkerElements(instance)].map((marker) => ({
    x: Number.parseFloat(marker.getAttribute("cx")),
    y: Number.parseFloat(marker.getAttribute("cy"))
  })).filter((point) => Number.isFinite(point.x) && Number.isFinite(point.y))

  return points.length ? points : null
}

export function hideCrosshair(instance) {
  const crosshair = instance?.el?.querySelector(".apexcharts-xcrosshairs")
  if (!crosshair) return

  crosshair.setAttribute("opacity", "0")
}

export function syncCrosshairToMarker(instance, index = null, { allowActiveFallback = false } = {}) {
  const crosshair = instance?.el?.querySelector(".apexcharts-xcrosshairs")
  if (!crosshair) return

  let centerX = null
  if (index != null) centerX = markerCenter(instance, index)?.x

  if (centerX == null && allowActiveFallback) {
    const activeMarker = instance.el.querySelector(
      ".apexcharts-series-markers .apexcharts-marker.apexcharts-active"
    )
    if (activeMarker) centerX = Number.parseFloat(activeMarker.getAttribute("cx"))
  }

  if (!Number.isFinite(centerX)) {
    hideCrosshair(instance)
    return
  }

  crosshair.setAttribute("opacity", "1")
  crosshair.setAttribute("x1", String(centerX))
  crosshair.setAttribute("x2", String(centerX))
}
